import { t } from 'i18next';
import { useTranslation } from 'react-i18next';

import { InfoCard } from 'core/components';
import { IProjectDetails } from 'projects/types';

interface IProps {
  project: IProjectDetails;
}

export const Location = ({ project }: IProps) => {
  const { t } = useTranslation();

  return <InfoCard title={t('titleLocation')} items={items(project)} />;
};

const items = (project: IProjectDetails) => [
  {
    label: t('labelCountry'),
    value: project.addressArr?.countryName,
  },
  {
    label: t('labelState'),
    value: project.addressArr?.state,
  },
  {
    label: t('labelCity'),
    value: project.addressArr?.city,
  },
  {
    label: t('labelPostalCode'),
    value: project.addressArr?.zip,
  },
  {
    label: t('labelStreetAddress'),
    value: [project.addressArr?.line1, project.addressArr?.line2].filter(Boolean).join(' '),
  },
];
